const BLOCK_TAG = 'p|div|h[1-6]|ul|ol|li|blockquote'
const EMPTY_PARAGRAPH = '<p>(?:<br\\s*\\/?>|\\s|&nbsp;)*<\\/p>'

const normalizeEditorHtml = (html: string) =>
  html
    .replace(new RegExp(`<(${BLOCK_TAG})([^>]*)>\\s+`, 'gi'), '<$1$2>')
    .replace(new RegExp(`</(${BLOCK_TAG})>\\s+`, 'gi'), '</$1>')
    .replace(new RegExp(`(?:${EMPTY_PARAGRAPH}\\s*){2,}`, 'gi'), '<p><br></p>')
    .trim()

export { normalizeEditorHtml }
